import { class_of_use_enum, type_of_use_enum } from '@predium/enums';

const classOfUseLookup: Record<type_of_use_enum, class_of_use_enum> = {
  [type_of_use_enum.MFH]: class_of_use_enum.RESIDENTIAL,
  [type_of_use_enum.SFH]: class_of_use_enum.RESIDENTIAL,
  [type_of_use_enum.DORM]: class_of_use_enum.RESIDENTIAL,
  [type_of_use_enum.COMMUNAL_ACCOMMODATION]: class_of_use_enum.RESIDENTIAL,
  [type_of_use_enum.ADMINISTRATIVE_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.CAFETERIA]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.CENTRAL_SERVICE_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.COLD_WAREHOUSE]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.DATA_CENTER]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.DOCTOR_OFFICE]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.EDUCATION_INSTITUTION]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.ELDERLY_DAYCARE_CENTER]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.EVENT_HALL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.EXHIBITION_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.EXHIBITION_HALL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.FIRE_DEPARTMENT]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.GYM]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.HOTEL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.LABORATORY_AND_RESEARCH_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.LECTURE_AND_TEACHING_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.LEISURE_AND_COMMUNITY_FACILITY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.LIBRARY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.LOGISTIC_STORAGE_OPERATION_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.MEDICAL_AND_NURSING_FACILITY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.OUTDOOR_SPORT_FACILITY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.PARKING_GARAGE]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.POLICE_STATION]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.PRODUCTION_AND_WORKSHOP_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.REHABILITATION_CENTER]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.RESTAURANT]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.RETAIL_FOOD]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.RETAIL_NON_FOOD]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.RIDING_AND_ICE_SPORT_HALL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.SHOPPING_CENTER]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.SPORT_AND_LEISURE_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.TRANSPORT_TERMINAL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.UNIVERSITY_AND_RESEARCH_INSTITUTION]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.UTILITY_AND_INFRASTRUCTURE_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.UTILITY_SERVICE_BUILDING]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.VEHICLE_FLEET_FACILITY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.VEHICLE_SERVICE_AND_INSPECTION_FACILITY]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.VEHICLE_STORAGE_HALL]: class_of_use_enum.COMMERCIAL,
  [type_of_use_enum.YOUTH_CENTER]: class_of_use_enum.COMMERCIAL,
};

export const commercialTypesOfUse = Object.keys(classOfUseLookup).filter(
  (typeOfUse) => classOfUseLookup[typeOfUse as type_of_use_enum] === class_of_use_enum.COMMERCIAL,
);
export const residentialTypesOfUse = Object.keys(classOfUseLookup).filter(
  (typeOfUse) => classOfUseLookup[typeOfUse as type_of_use_enum] === class_of_use_enum.RESIDENTIAL,
);
export const getClassOfUse = (typeOfUse: type_of_use_enum): class_of_use_enum => {
  return classOfUseLookup[typeOfUse];
};
